module.exports = __webpack_public_path__ + "img/image_online05@2x.c93e2468.png";